import '../assets/MazSelect.css';
import { getCurrentInstance as Me, computed as p, defineComponent as he, defineAsyncComponent as C, ref as I, onMounted as Le, useSlots as Te, openBlock as v, createElementBlock as w, normalizeClass as q, normalizeStyle as Y, createElementVNode as T, createCommentVNode as y, renderSlot as U, createBlock as A, unref as V, resolveDynamicComponent as me, withDirectives as be, mergeProps as ge, toHandlers as Ee, vModelDynamic as De, createTextVNode as Ne, toDisplayString as ue, withModifiers as F, withCtx as x, createVNode as H, useCssVars as Oe, onBeforeMount as Pe, nextTick as se, Transition as Fe, Fragment as ve, renderList as He } from "vue";
function qe(r, u) {
  let s;
  return function(...d) {
    clearTimeout(s), s = setTimeout(() => {
      r.apply(this, d);
    }, u);
  };
}
function ze({
  componentName: r,
  providedId: u
}) {
  const s = Me();
  return p(() => u ?? `${r}-${s == null ? void 0 : s.uid}`);
}
const Ue = {
  key: 0,
  class: "m-input-wrapper-left"
}, je = { class: "m-input-wrapper-input" }, Re = ["id", "type", "name", "inputmode", "placeholder", "aria-label", "disabled", "readonly", "required"], We = { key: 0 }, Qe = {
  key: 1,
  class: "m-input-wrapper-right"
}, Ge = /* @__PURE__ */ he({
  inheritAttrs: !1,
  __name: "MazInput",
  props: {
    style: { default: void 0 },
    class: { default: void 0 },
    modelValue: { default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    name: { default: void 0 },
    color: { default: "primary" },
    type: { default: "text" },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    id: { default: void 0 },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    warning: { type: Boolean, default: !1 },
    hint: { default: void 0 },
    inputClasses: { default: void 0 },
    noBorder: { type: Boolean, default: !1 },
    noRadius: { type: Boolean, default: !1 },
    inputmode: { default: "text" },
    size: { default: "md" },
    debounce: { type: [Boolean, Number], default: !1 },
    debounceDelay: { default: 500 },
    validButton: { type: Boolean, default: !1 },
    validButtonLoading: { type: Boolean, default: !1 },
    autoFocus: { type: Boolean, default: !1 },
    borderActive: { type: Boolean, default: !1 },
    leftIcon: { default: void 0 },
    rightIcon: { default: void 0 },
    roundedSize: { default: void 0 },
    block: { type: Boolean }
  },
  emits: ["update:model-value", "focus", "blur", "click", "change"],
  setup(r, { emit: u }) {
    const s = C(() => import("./MazBtn-BqgdERYQ.mjs")), d = C(() => import("./MazIcon-Cxrv3_OK.mjs")), i = C(() => import("./eye-slash-tjfxO0LK.mjs")), c = C(() => import("./eye-DqO_Jx56.mjs")), b = C(() => import("./check-7UA4j2f2.mjs")), t = r, z = u, k = I(!1), m = I(!1), E = I(), ee = ze({
      componentName: "MazInput",
      providedId: t.id
    });
    Le(() => {
      var o;
      t.autoFocus && ((o = E.value) == null || o.focus());
    });
    const W = p(() => t.type === "password"), te = p(() => k.value ? "text" : t.type), S = p(() => {
      if (!t.noBorder) {
        if (t.error)
          return "maz-border-danger";
        if (t.success)
          return "maz-border-success";
        if (t.warning)
          return "maz-border-warning";
        if (m.value || t.borderActive) {
          if (t.color === "black")
            return "maz-border-black";
          if (t.color === "danger")
            return "maz-border-danger";
          if (t.color === "info")
            return "maz-border-info";
          if (t.color === "primary")
            return "maz-border-primary";
          if (t.color === "secondary")
            return "maz-border-secondary";
          if (t.color === "success")
            return "maz-border-success";
          if (t.color === "warning")
            return "maz-border-warning";
          if (t.color === "white")
            return "maz-border-white";
        }
        return "--default-border";
      }
    }), j = Te(), Q = p(() => {
      const { required: o, placeholder: h } = t;
      if (h)
        return o ? `${h} *` : h;
    }), G = p(() => L.value !== void 0 && L.value !== ""), M = qe(
      (o) => {
        z("update:model-value", o);
      },
      typeof t.debounce == "number" ? t.debounce : t.debounceDelay ?? 500
    ), D = (o) => {
      if (t.debounce)
        return M(o);
      z("update:model-value", o);
    }, L = p({
      get: () => t.modelValue,
      set: (o) => D(o)
    }), Z = p(() => (!!t.label || !!t.hint) && (m.value || !!G.value || !!t.placeholder || ["date", "month", "week"].includes(t.type))), J = p(() => !!t.label || !!t.hint);
    function X() {
      return !!j["right-icon"] || W.value || !!j["valid-button"] || t.validButton || !!t.rightIcon;
    }
    function $() {
      return !!j["left-icon"] || !!t.leftIcon;
    }
    function R(o) {
      z("focus", o), m.value = !0;
    }
    function oe(o) {
      z("blur", o), m.value = !1;
    }
    function le(o) {
      return z("change", o);
    }
    return (o, h) => (v(), w(
      "div",
      {
        class: q(["m-input", [
          {
            "--is-focused": m.value || o.borderActive,
            "--should-up": Z.value,
            "--has-label": J.value,
            "--is-disabled": o.disabled,
            "--is-readonly": o.readonly,
            "--has-z-2": o.error || o.warning || o.success,
            "--has-state": o.error || o.warning || o.success,
            "--block": o.block
          },
          t.class,
          `--${o.color}`,
          `--${o.size}`
        ]]),
        style: Y(o.style)
      },
      [
        T(
          "div",
          {
            class: q(["m-input-wrapper", [
              o.inputClasses,
              S.value,
              o.roundedSize ? `--rounded-${o.roundedSize}` : { "maz-rounded": !o.noRadius }
            ]])
          },
          [
            $() ? (v(), w("div", Ue, [
              y(`
          @slot left-icon - The icon to display on the left of the input
        `),
              o.$slots["left-icon"] || o.leftIcon ? U(o.$slots, "left-icon", { key: 0 }, () => [
                typeof o.leftIcon == "string" ? (v(), A(V(d), {
                  key: 0,
                  name: o.leftIcon,
                  class: "maz-text-xl maz-text-muted"
                }, null, 8, ["name"])) : o.leftIcon ? (v(), A(me(o.leftIcon), {
                  key: 1,
                  class: "maz-text-xl maz-text-muted"
                })) : y("v-if", !0)
              ], !0) : y("v-if", !0)
            ])) : y("v-if", !0),
            T("div", je, [
              be(T("input", ge({
                id: V(ee),
                ref_key: "input",
                ref: E,
                "onUpdate:modelValue": h[0] || (h[0] = (B) => L.value = B),
                type: te.value,
                name: o.name
              }, o.$attrs, {
                inputmode: o.inputmode,
                placeholder: Q.value,
                "aria-label": o.label || o.placeholder,
                disabled: o.disabled,
                readonly: o.readonly,
                required: o.required,
                class: "m-input-input"
              }, Ee({
                blur: oe,
                focus: R,
                change: le
              }, !0), {
                onClick: h[1] || (h[1] = (B) => o.$emit("click", B))
              }), null, 16, Re), [
                [De, L.value]
              ]),
              o.label || o.hint ? (v(), w(
                "span",
                {
                  key: 0,
                  ref: "label",
                  class: q(["m-input-label", [
                    {
                      "maz-text-danger-600": o.error,
                      "maz-text-success-600": o.success,
                      "maz-text-warning-600": o.warning
                    }
                  ]])
                },
                [
                  Ne(
                    ue(o.hint || o.label) + " ",
                    1
                    /* TEXT */
                  ),
                  o.required ? (v(), w("sup", We, "*")) : y("v-if", !0)
                ],
                2
                /* CLASS */
              )) : y("v-if", !0)
            ]),
            X() ? (v(), w("div", Qe, [
              y(`
          @slot right-icon - The icon to display on the right of the input
        `),
              o.$slots["right-icon"] || o.rightIcon ? U(o.$slots, "right-icon", { key: 0 }, () => [
                typeof o.rightIcon == "string" ? (v(), A(V(d), {
                  key: 0,
                  name: o.rightIcon,
                  class: "maz-text-xl maz-text-muted"
                }, null, 8, ["name"])) : o.rightIcon ? (v(), A(me(o.rightIcon), {
                  key: 1,
                  class: "maz-text-xl maz-text-muted"
                })) : y("v-if", !0)
              ], !0) : y("v-if", !0),
              W.value ? (v(), A(V(s), {
                key: 1,
                color: "transparent",
                tabindex: "-1",
                size: "mini",
                onClick: h[2] || (h[2] = F((B) => k.value = !k.value, ["stop"]))
              }, {
                default: x(() => [
                  k.value ? (v(), A(V(i), {
                    key: 0,
                    class: "maz-text-xl maz-text-muted"
                  })) : (v(), A(V(c), {
                    key: 1,
                    class: "maz-text-xl maz-text-muted"
                  }))
                ]),
                _: 1
                /* STABLE */
              })) : y("v-if", !0),
              y(`
          @slot valid-button - Replace the valid button by your own
        `),
              o.$slots["valid-button"] || o.validButton ? U(o.$slots, "valid-button", { key: 2 }, () => [
                H(V(s), {
                  color: "transparent",
                  disabled: o.disabled,
                  tabindex: "-1",
                  loading: o.validButtonLoading,
                  class: "m-input-valid-button",
                  size: "mini",
                  type: "submit"
                }, {
                  default: x(() => [
                    H(V(b), { class: "maz-text-2xl maz-text-normal" })
                  ]),
                  _: 1
                  /* STABLE */
                }, 8, ["disabled", "loading"])
              ], !0) : y("v-if", !0)
            ])) : y("v-if", !0)
          ],
          2
          /* CLASS */
        )
      ],
      6
      /* CLASS, STYLE */
    ));
  }
}), Ve = (r, u) => {
  const s = r.__vccOpts || r;
  for (const [d, i] of u)
    s[d] = i;
  return s;
}, ye = /* @__PURE__ */ Ve(Ge, [["__scopeId", "data-v-84073434"]]);
let ie = null;
function Ze(r, u) {
  ie && clearTimeout(ie), ie = setTimeout(r, u);
}
const Je = {
  removeAccents: !0,
  caseSensitive: !1,
  replaceSpaces: !0,
  removeSpecialCharacters: !1,
  trim: !0,
  normalizeSpaces: !0,
  removeNumbers: !1,
  customNormalizationForms: ["NFC", "NFKD"]
};
function _(r, u) {
  const s = { ...Je, ...u }, d = {
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Î: "I",
    Ï: "I",
    í: "I",
    î: "i",
    ï: "i",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ç: "C",
    ç: "c",
    ÿ: "y",
    Ñ: "N",
    ñ: "n",
    ó: "o"
  };
  let i = r.toString();
  if (s.trim && (i = i.trim()), s.normalizeSpaces && (i = i.replaceAll(/\s+/g, " ")), s.replaceSpaces && (i = i.replaceAll(" ", "-")), s.removeNumbers && (i = i.replaceAll(/\d/g, "")), s.removeAccents && (i = i.replaceAll(/[ÀÁÂÃÄÅÇÈÉÊËÎÏÑÔÕÖØÙÚÛÜàáâãäåçèéêëíîïñóôõöøùúûüÿ]/g, (c) => d[c] || c), i = i.replaceAll(/[\u0300-\u036F]/g, "")), s.caseSensitive === !1 && (i = i.toLowerCase()), s.removeSpecialCharacters && (i = i.replaceAll(/[^\dA-Za-z-]/g, "")), s.trim && (i = i.trim()), s.customNormalizationForms)
    for (const c of s.customNormalizationForms)
      i = i.normalize(c);
  return i;
}
function Xe(r, u) {
  const s = r.length, d = u.length, i = [];
  for (let c = 0; c <= s; c++)
    i[c] = [c];
  for (let c = 0; c <= d; c++)
    i[0][c] = c;
  for (let c = 1; c <= s; c++)
    for (let b = 1; b <= d; b++) {
      const t = r[c - 1] === u[b - 1] ? 0 : 1;
      i[c][b] = Math.min(
        i[c - 1][b] + 1,
        i[c][b - 1] + 1,
        i[c - 1][b - 1] + t
      );
    }
  return i[s][d];
}
function ke(r, u) {
  const s = Xe(r, u), d = Math.max(r.length, u.length);
  return 1 - s / d;
}
function Ye(r, u, s = 0.75) {
  return ke(r, u) >= s;
}
function re(r, u, s = 0.75) {
  const d = p(
    () => _(typeof r == "string" ? r : r.value)
  ), i = p(
    () => _(typeof u == "string" ? u : u.value)
  ), c = p(() => typeof s == "number" ? s : s.value), b = p(() => ke(d.value, i.value));
  return {
    isMatching: p(
      () => Ye(d.value, i.value, c.value)
    ),
    score: b
  };
}
const Ie = (r, u, s) => {
  var b;
  r.stopPropagation();
  const d = typeof s.value == "function" ? s.value : s.value.handler, i = typeof s.value == "object" ? s.value.exclude : void 0;
  let c = !1;
  if (i && i.length > 0) {
    for (const t of i)
      if (!c && r.target instanceof HTMLElement) {
        const z = (b = document.querySelector(t)) == null ? void 0 : b.getAttribute("id");
        c = r.target.getAttribute("id") === z;
      }
  }
  !u.contains(r.target) && !c && (d == null || d());
};
function we() {
  return document.ontouchstart === null ? "touchstart" : "click";
}
function xe(r, u) {
  const s = we();
  document.removeEventListener(s, (d) => Ie(d, r, u));
}
function _e(r, u) {
  if (typeof u.value != "function" && typeof u.value == "object" && typeof u.value.handler != "function") {
    console.error("[maz-ui](vClosable) v-closable directive requires a handler function");
    return;
  }
  const s = we();
  document.addEventListener(s, (d) => Ie(d, r, u));
}
const et = {
  mounted: _e,
  unmounted: xe
}, tt = ["aria-label"], ot = { class: "m-select-list__no-results" }, lt = {
  key: 2,
  class: "m-select-list__scroll-wrapper",
  tabindex: "-1"
}, at = { class: "m-select-list-optgroup" }, nt = ["onClick"], st = /* @__PURE__ */ he({
  inheritAttrs: !1,
  __name: "MazSelect",
  props: {
    style: { default: void 0 },
    class: { default: void 0 },
    id: { default: void 0 },
    modelValue: { default: void 0 },
    options: { default: void 0 },
    optionValueKey: { default: "value" },
    optionLabelKey: { default: "label" },
    optionInputValueKey: { default: "label" },
    listPosition: { default: "bottom left" },
    itemHeight: { default: void 0 },
    maxListHeight: { default: 240 },
    maxListWidth: { default: void 0 },
    size: { default: "md" },
    color: { default: "primary" },
    search: { type: Boolean },
    searchPlaceholder: { default: "Search in options" },
    open: { type: Boolean },
    multiple: { type: Boolean, default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    block: { type: Boolean },
    excludeSelectors: { default: void 0 }
  },
  emits: ["close", "open", "blur", "focus", "change", "update:model-value", "selected-option"],
  setup(r, { expose: u, emit: s }) {
    Oe((e) => ({
      "416802e0": te.value,
      "21823f4f": ee.value,
      "6d76cd12": W.value
    }));
    const d = C(() => import("./MazCheckbox-DsFbvpp4.mjs")), i = C(() => import("./magnifying-glass-DZGg7953.mjs")), c = C(() => import("./chevron-down-CzMH-gFW.mjs")), b = C(() => import("./no-symbol-QAqP9IlR.mjs"));
    u({
      /** Method to open the option list */
      openList: O,
      /** Method to close the option list */
      closeList: N
    });
    const t = r, z = s, k = I(!1), m = I(), E = p(
      () => ["black", "transparent", "white"].includes(t.color)
    ), ee = p(
      () => E.value ? "var(--maz-color-black)" : `var(--maz-color-${t.color}-800)`
    ), W = p(
      () => E.value ? "var(--maz-color-muted)" : `var(--maz-color-${t.color}-100)`
    ), te = p(
      () => E.value ? "var(--maz-color-muted)" : `var(--maz-color-${t.color}-200)`
    ), S = p(() => k.value || t.open), j = ze({
      componentName: "MazSelect",
      providedId: t.id
    });
    function Q(e) {
      return {
        [t.optionValueKey]: e,
        [t.optionLabelKey]: e,
        [t.optionInputValueKey]: e
      };
    }
    function G(e) {
      return {
        ...e,
        [t.optionValueKey]: e[t.optionValueKey],
        [t.optionLabelKey]: e[t.optionLabelKey],
        [t.optionInputValueKey]: e[t.optionInputValueKey]
      };
    }
    const M = p(() => {
      var l;
      const e = [];
      if (!((l = t.options) != null && l.length))
        return [];
      for (const n of t.options)
        typeof n == "string" || typeof n == "number" || typeof n == "boolean" ? e.push(Q(n)) : typeof n == "object" && "options" in n && Array.isArray(n.options) ? e.push(
          { label: n.label, isOptGroup: !0 },
          ...n.options.map(
            (a) => typeof a == "string" || typeof a == "number" || typeof a == "boolean" ? Q(a) : G(a)
          )
        ) : e.push(G(n));
      return e;
    }), D = p(
      () => {
        var e;
        return ((e = M.value) == null ? void 0 : e.filter((l) => t.multiple ? Array.isArray(t.modelValue) ? t.modelValue.includes(l[t.optionValueKey]) && !$(l[t.optionValueKey]) : !1 : t.modelValue === l[t.optionValueKey] && !$(l[t.optionValueKey]))) ?? [];
      }
    );
    Pe(() => {
      var e;
      (e = t.options) != null && e.length || console.warn("[maz-ui](MazSelect) you must provide options"), ne();
    });
    const L = I(), Z = I(), J = I(), X = I(), $ = (e) => e == null;
    function R(e) {
      var n;
      return (((n = D.value) == null ? void 0 : n.some(
        (a) => a[t.optionValueKey] === e[t.optionValueKey]
      )) ?? !1) && !$(e[t.optionValueKey]);
    }
    const oe = p(() => {
      var l;
      if (t.multiple && t.modelValue && Array.isArray(t.modelValue))
        return t.modelValue.map(
          (n) => {
            var a, f;
            return (f = (a = M.value) == null ? void 0 : a.find((g) => g[t.optionValueKey] === n)) == null ? void 0 : f[t.optionInputValueKey];
          }
        ).join(", ");
      const e = (l = M.value) == null ? void 0 : l.find(
        (n) => n[t.optionValueKey] === t.modelValue
      );
      return $(t.modelValue) || e == null ? void 0 : e[t.optionInputValueKey];
    }), le = p(
      () => t.listPosition.includes("bottom") ? "maz-slide" : "maz-slideinvert"
    ), o = I(""), h = I(""), B = (e, l) => l && e && _(e).includes(_(l));
    function ce(e) {
      var l;
      return e ? (l = M.value) == null ? void 0 : l.filter((n) => {
        const a = n[t.optionLabelKey], f = n[t.optionValueKey], g = n[t.optionInputValueKey];
        return B(a, e) || B(g, e) || B(f, e) || typeof a == "string" && re(a, e, 0.5).isMatching.value || typeof g == "string" && re(g, e, 0.5).isMatching.value || typeof f == "string" && re(f, e, 0.5).isMatching.value;
      }) : M.value;
    }
    const K = p(() => ce(o.value));
    async function N(e) {
      var n, a;
      if (!S.value)
        return;
      if (e && ("relatedTarget" in e && ((n = L.value) != null && n.contains(e.relatedTarget)) || e.type === "keydown"))
        return e.preventDefault();
      const l = e && "relatedTarget" in e && e.relatedTarget instanceof HTMLElement && e.relatedTarget.getAttribute("id");
      if ((a = t.excludeSelectors) != null && a.includes(`#${l}`))
        return e == null ? void 0 : e.preventDefault();
      await se(), k.value = !1, m.value = 0, z("close", e);
    }
    async function O(e) {
      t.disabled || S.value || (e == null || e.preventDefault(), k.value = !0, await ae(), z("focus", e), z("open", k.value));
    }
    function de() {
      var e, l;
      (l = ((e = Z.value) == null ? void 0 : e.$el).querySelector("input")) == null || l.focus();
    }
    function Se(e) {
      k.value ? N(e) : de();
    }
    function Ke(e) {
      var l, n;
      o.value = e, (n = ((l = J.value) == null ? void 0 : l.$el).querySelector("input")) == null || n.focus();
    }
    function Ae(e) {
      var n;
      e === "Backspace" && h.value.length > 0 ? h.value = h.value.slice(0, -1) : h.value += e;
      const l = ce(h.value);
      l != null && l.length && (m.value = (n = K.value) == null ? void 0 : n.findIndex(
        (a) => a[t.optionValueKey] === l[0][t.optionValueKey]
      ), typeof m.value == "number" && m.value >= 0 && ae(m.value)), Ze(() => {
        h.value = "";
      }, 1e3);
    }
    const Ce = (e) => {
      const l = e.key;
      /^[\dA-Za-z\u0400-\u04FF]$/.test(l) ? (e.preventDefault(), O(e), t.search ? Ke(l) : Ae(l)) : pe(e);
    }, pe = (e) => {
      const l = e.code, n = ["ArrowUp", "ArrowDown"].includes(l), a = ["Enter", "Space"].includes(l), f = l === "Escape" && S.value;
      n ? $e(e, m.value) : a ? Be(e, m.value) : f && N(e);
    }, $e = (e, l) => {
      var f;
      e.preventDefault();
      const n = e.code;
      S.value || O(e);
      const a = (f = K.value) == null ? void 0 : f.length;
      a && (typeof l == "number" ? l === a - 1 && n === "ArrowDown" ? m.value = 0 : l === 0 && n === "ArrowUp" ? m.value = a - 1 : m.value = n === "ArrowDown" ? l + 1 : l - 1 : m.value = n === "ArrowDown" ? 0 : a - 1, ae(m.value));
    }, Be = (e, l) => {
      var a, f, g;
      if (e.preventDefault(), !S.value)
        return O(e);
      const n = l ? ((a = K.value) == null ? void 0 : a[l]) ?? ((f = K.value) == null ? void 0 : f[0]) : (g = K.value) == null ? void 0 : g[0];
      $(n) || fe(n);
    };
    async function ae(e) {
      var n, a;
      await se(), typeof e != "number" && ne();
      const l = e ?? m.value;
      typeof l == "number" && l >= 0 && ((a = (n = X.value) == null ? void 0 : n.querySelectorAll(".m-select-list-item")[l]) == null || a.scrollIntoView({
        behavior: "auto",
        block: "nearest",
        inline: "start"
      }));
    }
    function ne(e) {
      var n;
      const l = (n = K.value) == null ? void 0 : n.findIndex((a) => {
        var f, g;
        return t.multiple && Array.isArray(t.modelValue) ? e ? e[t.optionValueKey] === a[t.optionValueKey] : [...t.modelValue].reverse()[0] === a[t.optionValueKey] : ((g = (f = D.value) == null ? void 0 : f[0]) == null ? void 0 : g[t.optionValueKey]) === a[t.optionValueKey];
      });
      m.value = l && l >= 0 ? l : 0;
    }
    function fe(e, l = !0) {
      var g;
      l && !t.multiple && se(() => N()), o.value = "";
      const n = (g = D.value) == null ? void 0 : g.some(
        (P) => P[t.optionValueKey] === e[t.optionValueKey]
      );
      let a = D.value;
      n && t.multiple ? a = a == null ? void 0 : a.filter(
        (P) => P[t.optionValueKey] !== e[t.optionValueKey]
      ) : t.multiple ? a.push(e) : a = [e];
      const f = a.map((P) => P[t.optionValueKey]);
      z("update:model-value", t.multiple ? f : f[0]), z("selected-option", e), ne(e), de();
    }
    return (e, l) => {
      var n;
      return be((v(), w(
        "div",
        {
          ref_key: "mazSelectElement",
          ref: L,
          class: q(["m-select", [
            { "--is-open": S.value, "--disabled": e.disabled, "--block": e.block },
            t.class,
            `--${e.size}`
          ]]),
          style: Y(e.style)
        },
        [
          H(ye, ge({
            id: V(j),
            ref_key: "mazInputComponent",
            ref: Z,
            class: "m-select-input"
          }, e.$attrs, {
            required: e.required,
            "border-active": k.value,
            color: e.color,
            "model-value": oe.value,
            autocomplete: "off",
            size: e.size,
            block: "",
            disabled: e.disabled,
            onFocus: F(O, ["prevent", "stop"]),
            onBlur: F(N, ["prevent", "stop"]),
            onClick: F(O, ["prevent", "stop"]),
            onChange: l[0] || (l[0] = (a) => z("change", a)),
            onKeydown: Ce
          }), {
            "right-icon": x(() => [
              T("button", {
                tabindex: "-1",
                type: "button",
                class: "m-select-input__toggle-button maz-custom",
                "aria-label": `${S.value ? "collapse" : "expand"} list of options`,
                onClick: F(Se, ["stop"])
              }, [
                H(V(c), { class: "m-select-chevron maz-text-xl" })
              ], 8, tt)
            ]),
            _: 1
            /* STABLE */
          }, 16, ["id", "required", "border-active", "color", "model-value", "size", "disabled"]),
          H(Fe, { name: le.value }, {
            default: x(() => [
              S.value ? (v(), w(
                "div",
                {
                  key: 0,
                  ref_key: "optionsListElement",
                  ref: X,
                  class: q(["m-select-list", {
                    "--top": e.listPosition.includes("top"),
                    "--left": e.listPosition.includes("left"),
                    "--right": e.listPosition.includes("right"),
                    "--bottom": e.listPosition.includes("bottom")
                  }]),
                  style: Y({
                    maxHeight: `${e.maxListHeight}px`,
                    maxWidth: `${e.maxListWidth}px`
                  })
                },
                [
                  e.search ? (v(), A(ye, {
                    key: 0,
                    ref_key: "searchInputComponent",
                    ref: J,
                    modelValue: o.value,
                    "onUpdate:modelValue": [
                      l[1] || (l[1] = (a) => o.value = a),
                      l[2] || (l[2] = (a) => m.value = 0)
                    ],
                    size: "sm",
                    color: e.color,
                    placeholder: e.searchPlaceholder,
                    name: "search",
                    autocomplete: "off",
                    tabindex: "-1",
                    class: "m-select-list__search-input maz-flex-none",
                    "left-icon": V(i),
                    onKeydown: pe
                  }, null, 8, ["modelValue", "color", "placeholder", "left-icon"])) : y("v-if", !0),
                  y(`
          @slot No results slot - Displayed when no results corresponding with search query
        `),
                  !K.value || K.value.length <= 0 ? U(e.$slots, "no-results", { key: 1 }, () => [
                    T("span", ot, [
                      H(V(b), { class: "maz-h-6 maz-w-6 maz-text-normal" })
                    ])
                  ], !0) : (v(), w("div", lt, [
                    (v(!0), w(
                      ve,
                      null,
                      He(K.value, (a, f) => (v(), w(
                        ve,
                        { key: f },
                        [
                          y(`
              @slot Custom optgroup label
                @binding {String} label - the label of the optgroup
            `),
                          a.label && a.isOptGroup ? U(e.$slots, "optgroup", {
                            key: 0,
                            label: a.label
                          }, () => [
                            T(
                              "span",
                              at,
                              ue(a.label),
                              1
                              /* TEXT */
                            )
                          ], !0) : (v(), w("button", {
                            key: 1,
                            tabindex: "-1",
                            type: "button",
                            class: q(["m-select-list-item maz-custom maz-flex-none", [
                              {
                                "--is-keyboard-selected": m.value === f,
                                "--is-selected": R(a),
                                "--is-none-value": $(a[e.optionValueKey])
                              }
                            ]]),
                            style: Y(e.itemHeight ? { height: `${e.itemHeight}px` } : void 0),
                            onClick: F((g) => fe(a), ["prevent", "stop"])
                          }, [
                            e.multiple ? (v(), A(V(d), {
                              key: 0,
                              tabindex: "-1",
                              "model-value": R(a),
                              size: "sm",
                              color: e.color
                            }, null, 8, ["model-value", "color"])) : y("v-if", !0),
                            y(`
                @slot Custom option
                  @binding {Object} option - the option object
                  @binding {Boolean} is-selected - if the option is selected
              `),
                            U(e.$slots, "default", {
                              option: a,
                              isSelected: R(a)
                            }, () => [
                              T(
                                "span",
                                null,
                                ue(a[e.optionLabelKey]),
                                1
                                /* TEXT */
                              )
                            ], !0)
                          ], 14, nt))
                        ],
                        64
                        /* STABLE_FRAGMENT */
                      ))),
                      128
                      /* KEYED_FRAGMENT */
                    ))
                  ]))
                ],
                6
                /* CLASS, STYLE */
              )) : y("v-if", !0)
            ]),
            _: 3
            /* FORWARDED */
          }, 8, ["name"])
        ],
        6
        /* CLASS, STYLE */
      )), [
        [V(et), {
          exclude: (n = e.excludeSelectors) != null && n.length ? e.excludeSelectors : [],
          handler: N
        }]
      ]);
    };
  }
}), rt = /* @__PURE__ */ Ve(st, [["__scopeId", "data-v-05b98a1b"]]);
export {
  rt as M,
  Ve as _,
  ze as u
};
